<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="offset-md-3" [formGroup]="payPalGroup">
  <fieldset>
    <div
      class="form-group fieldIsRequired"
      [ngClass]="{ fieldIsRequired: editMode }"
    >
      <label class="col-md-4 control-label" for="paypalPartner">
        Partner
      </label>
      <div class="col-md-8">
        <select
          class="form-control"
          formControlName="paypalPartner"
          [ngClass]="{
            'is-invalid':
              payPalGroupControls.paypalPartner.invalid &&
              (payPalGroupControls.paypalPartner.dirty ||
                payPalGroupControls.paypalPartner.touched)
          }"
          id="paypalPartner"
        >
          <option value="">--- Select Partner ---</option>
          <option
            *ngFor="let partner of ['Medfusion', 'PayPal', 'Verisign']"
            [value]="partner"
          >
            {{ partner }}
          </option>
        </select>

        <div
          class="formValidationMessage mt-1"
          *ngIf="
            payPalGroupControls.paypalPartner.invalid &&
            (payPalGroupControls.paypalPartner.dirty ||
              payPalGroupControls.paypalPartner.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="payPalGroupControls.paypalPartner.errors?.required"
          >
            Field is required.
          </div>
        </div>
      </div>
    </div>

    <div
      class="form-group fieldIsRequired"
      [ngClass]="{ fieldIsRequired: editMode }"
    >
      <label class="col-md-8 control-label" for="paypalCardNotPresentUsername">
        Card Not Present Username
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          [ngClass]="{
            'is-invalid':
              payPalGroupControls.paypalCardNotPresentUsername.invalid &&
              (payPalGroupControls.paypalCardNotPresentUsername.dirty ||
                payPalGroupControls.paypalCardNotPresentUsername.touched)
          }"
          type="text"
          formControlName="paypalCardNotPresentUsername"
          id="paypalCardNotPresentUsername"
        />

        <div
          class="formValidationMessage mt-1"
          *ngIf="
            payPalGroupControls.paypalCardNotPresentUsername.invalid &&
            (payPalGroupControls.paypalCardNotPresentUsername.dirty ||
              payPalGroupControls.paypalCardNotPresentUsername.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="
              payPalGroupControls.paypalCardNotPresentUsername.errors?.required
            "
          >
            Field is required.
          </div>
          <div
            class="text-danger"
            *ngIf="
              payPalGroupControls.paypalCardNotPresentUsername.errors?.maxlength
            "
          >
            Username cannot be longer than 64 characters.
          </div>
        </div>
      </div>
    </div>

    <div formGroupName="cardNotPresentPasswordGroup">
      <div class="form-group">
        <label
          class="col-md-8 control-label"
          for="paypalCardNotPresentPassword"
        >
          Card Not Present Password<span *ngIf="editMode">
            (leave blank if unchanged)</span
          >
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid':
                cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                  .invalid &&
                (cardNotPresentPasswordGroupControls
                  .paypalCardNotPresentPassword.dirty ||
                  cardNotPresentPasswordGroupControls
                    .paypalCardNotPresentPassword.touched)
            }"
            type="password"
            formControlName="paypalCardNotPresentPassword"
            id="paypalCardNotPresentPassword"
          />

          <div
            class="formValidationMessage mt-1"
            *ngIf="
              cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                .invalid &&
              (cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                .dirty ||
                cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                  .errors?.required
              "
            >
              Field is required.
            </div>
            <div
              class="text-danger"
              *ngIf="
                cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                  .errors?.maxlength
              "
            >
              Password cannot be longer than 32 characters.
            </div>
            <div
              class="text-danger"
              *ngIf="
                cardNotPresentPasswordGroupControls.paypalCardNotPresentPassword
                  .errors?.minlength
              "
            >
              Password must be at least 6 characters.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          class="col-md-4 control-label"
          for="paypalCardNotPresentPasswordVerify"
        >
          Verify Card Not Present Password
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid':
                cardNotPresentPasswordGroupControls
                  .paypalCardNotPresentPasswordVerify.invalid &&
                (cardNotPresentPasswordGroupControls
                  .paypalCardNotPresentPasswordVerify.dirty ||
                  cardNotPresentPasswordGroupControls
                    .paypalCardNotPresentPasswordVerify.touched)
            }"
            type="password"
            formControlName="paypalCardNotPresentPasswordVerify"
            id="paypalCardNotPresentPasswordVerify"
          />

          <div
            class="formValidationMessage mt-1"
            *ngIf="
              cardNotPresentPasswordGroupControls
                .paypalCardNotPresentPasswordVerify.invalid &&
              (cardNotPresentPasswordGroupControls
                .paypalCardNotPresentPasswordVerify.dirty ||
                cardNotPresentPasswordGroupControls
                  .paypalCardNotPresentPasswordVerify.touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                cardNotPresentPasswordGroupControls
                  .paypalCardNotPresentPasswordVerify.errors?.maxlength
              "
            >
              Password cannot be longer than 32 characters.
            </div>
            <div
              class="text-danger"
              *ngIf="
                cardNotPresentPasswordGroupControls
                  .paypalCardNotPresentPasswordVerify.errors?.minlength
              "
            >
              Password must be at least 6 characters.
            </div>
            <div
              class="text-danger"
              *ngIf="
                payPalGroupControls.cardNotPresentPasswordGroup.errors
                  ?.passwordNotEqual
              "
            >
              Passwords do not match.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="col-md-8 control-label" for="paypalCardPresentUsername">
        Card Present Username
      </label>
      <div class="col-md-8">
        <input
          class="form-control"
          [ngClass]="{
            'is-invalid':
              payPalGroupControls.paypalCardPresentUsername.invalid &&
              (payPalGroupControls.paypalCardPresentUsername.dirty ||
                payPalGroupControls.paypalCardPresentUsername.touched)
          }"
          type="text"
          formControlName="paypalCardPresentUsername"
          id="paypalCardPresentUsername"
        />

        <div
          class="formValidationMessage mt-1"
          *ngIf="
            payPalGroupControls.paypalCardPresentUsername.invalid &&
            (payPalGroupControls.paypalCardPresentUsername.dirty ||
              payPalGroupControls.paypalCardPresentUsername.touched)
          "
        >
          <div
            class="text-danger"
            *ngIf="
              payPalGroupControls.paypalCardPresentUsername.errors?.maxlength
            "
          >
            Username cannot be longer than 64 characters.
          </div>
        </div>
      </div>
    </div>

    <div formGroupName="cardPresentPasswordGroup">
      <div class="form-group">
        <label class="col-md-8 control-label" for="paypalCardPresentPassword">
          Card Present Password<span *ngIf="editMode">
            (leave blank if unchanged)</span
          >
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid':
                cardPresentPasswordGroupControls.paypalCardPresentPassword
                  .invalid &&
                (cardPresentPasswordGroupControls.paypalCardPresentPassword
                  .dirty ||
                  cardPresentPasswordGroupControls.paypalCardPresentPassword
                    .touched)
            }"
            type="password"
            formControlName="paypalCardPresentPassword"
            id="paypalCardPresentPassword"
          />

          <div
            class="formValidationMessage mt-1"
            *ngIf="
              cardPresentPasswordGroupControls.paypalCardPresentPassword
                .invalid &&
              (cardPresentPasswordGroupControls.paypalCardPresentPassword
                .dirty ||
                cardPresentPasswordGroupControls.paypalCardPresentPassword
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                cardPresentPasswordGroupControls.paypalCardPresentPassword
                  .errors?.maxlength
              "
            >
              Password cannot be longer than 32 characters.
            </div>
            <div
              class="text-danger"
              *ngIf="
                cardPresentPasswordGroupControls.paypalCardPresentPassword
                  .errors?.minlength
              "
            >
              Password must be at least 6 characters.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          class="col-md-8 control-label"
          for="paypalCardNotPresentPasswordVerify"
        >
          Verify Card Present Password
        </label>
        <div class="col-md-8">
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid':
                cardPresentPasswordGroupControls.paypalCardPresentPasswordVerify
                  .invalid &&
                (cardPresentPasswordGroupControls
                  .paypalCardPresentPasswordVerify.dirty ||
                  cardPresentPasswordGroupControls
                    .paypalCardPresentPasswordVerify.touched)
            }"
            type="password"
            formControlName="paypalCardPresentPasswordVerify"
            id="paypalCardPresentPasswordVerify"
          />

          <div
            class="formValidationMessage mt-1"
            *ngIf="
              cardPresentPasswordGroupControls.paypalCardPresentPasswordVerify
                .invalid &&
              (cardPresentPasswordGroupControls.paypalCardPresentPasswordVerify
                .dirty ||
                cardPresentPasswordGroupControls.paypalCardPresentPasswordVerify
                  .touched)
            "
          >
            <div
              class="text-danger"
              *ngIf="
                cardPresentPasswordGroupControls.paypalCardPresentPasswordVerify
                  .errors?.maxlength
              "
            >
              Password cannot be longer than 32 characters.
            </div>
            <div
              class="text-danger"
              *ngIf="
                cardPresentPasswordGroupControls.paypalCardPresentPasswordVerify
                  .errors?.minlength
              "
            >
              Password must be at least 6 characters.
            </div>
            <div
              class="text-danger"
              *ngIf="
                payPalGroupControls.cardPresentPasswordGroup.errors
                  ?.passwordNotEqual
              "
            >
              Passwords do not match.
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
